import React, { useEffect } from "react";
import Header from "../../components/header";
import "./conservepage.css";
import HomeVideo from "../../assets/DSC00026.webp";
import FeatureStories from "./FeatureStories";
import FlipCard from "./FlipCard";
import OtherEnvironmentalTargetsCharts from "./OtherEnvironmentalTargetsCharts";
import { ParallaxProvider } from "react-scroll-parallax";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import BlueParagraph from "./blueParagraph";

export default function Homepage() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("next-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        {/* home video */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
              {/* <video
              autoPlay
              loop
              muted
              className="home-video"
              style={{ height: "100vh", width: "100%", objectFit: "cover" }}
            >
              <source src={HomeVideo} type="video/mp4" />
            </video> */}
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="conserve-video-text-box">
              <div className="video-background-text">
                <Parallax speed={10}>
                  <h1 className="conserve-topic-home">Conserve</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                  Conserve <br />
                  {/* <span className="white-box-container-h1">Apparel Solutions</span> */}
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                Conserve <br />
                  {/* <span className="white-box-container-h1">
                    Apparel <br />
                    Solutions
                  </span> */}
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}
        <BlueParagraph />

        {/* section-3 */}
        <div className="conserve-card">
          <div className="para-box">
            <div data-aos="fade-up-left" data-aos-duration="500">
              <h2 className="para-one-1">
                In our Future First roadmap, we concentrate
              </h2>
              <h2 className="para-one-2">
                our conservation efforts on four main areas:
              </h2>
            </div>
            <div data-aos="zoom-in">
              <h1 className="para-two">CONSERVE</h1>
            </div>
            <div className="flip-part-new">
              <FlipCard />
            </div>
          </div>
        </div>

        {/* section-4 */}
        <OtherEnvironmentalTargetsCharts />

        {/* section-5 */}
        <FeatureStories />
      </div>
    </ParallaxProvider>
  );
}
